import { render, staticRenderFns } from "./Novelty.vue?vue&type=template&id=74bb6d4a&scoped=true"
import script from "./Novelty.vue?vue&type=script&lang=js"
export * from "./Novelty.vue?vue&type=script&lang=js"
import style0 from "./Novelty.vue?vue&type=style&index=0&id=74bb6d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb6d4a",
  null
  
)

export default component.exports